module.exports = __webpack_public_path__ + "assets/eb84be5f1d98aa8c18a59950f4813ef4.png";